/**
 * TrackSkeletion
 * 
 * @Author: Focci
 * @Date: 2023-08-17 14:46:44
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 14:46:44
 */

// import PropTypes from 'prop-types'
import { Skeleton } from '@comp/material'

export default function TrackSkeletion() {
  return (
    <div className="flex flex-col items-center w-full mb-10 max-w-[30rem] mx-auto">
      <Skeleton style={{ height: '3rem', width: '40%' }} />
      <div className="mt-4" />
      <Skeleton style={{ width: '80%' }} />
      <Skeleton style={{ width: '60%' }} />
      <Skeleton style={{ width: '70%' }} />
      <div className="mt-4" />
      <Skeleton style={{ width: '80%' }} />
      <Skeleton style={{ width: '60%' }} />
      <Skeleton style={{ width: '70%' }} />
    </div>
  )
}

// TrackSkeletion.propTypes = {
//   className: PropTypes.string,
// }
